import React from 'react';

const FooterComponent = () => {
    const year = new Date().getFullYear();
    return (
        <footer style={styles.footer}>
            <span style={styles.text}>© {year} Social CRM by CloudFlick. All rights reserved.</span>
        </footer>
    );
};

const styles = {
    footer: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '36px', background: '#f8fafc', borderTop: '1px solid #e5e7eb', flexShrink: 0 },
    text: { fontSize: '12px', color: '#9ca3af' },
};

export default FooterComponent;
